const memberId = (shift) => {
  const value = shift.store_team_member !== undefined ? shift.store_team_member : shift.store_team_member_id;
  return value && typeof value === "object" ? value.id : value;
};

const signature = (shift) => JSON.stringify([
  shift.date, memberId(shift) ?? null, shift.role_id ?? shift.role_id_id ?? null, shift.role_type,
  Number(shift.shift_start), Number(shift.shift_end),
  Number(shift.break_start || 0), Number(shift.break_length || 0),
  Number(shift.break_start_2 || 0), Number(shift.break_length_2 || 0),
  (shift.paid_breaks || []).filter((item) => !item.is_archived)
    .map((item) => [Number(item.break_start), Number(item.break_duration)]).sort((a, b) => a[0] - b[0]),
]);

export function changedScheduleRows(schedule, other) {
  const remaining = new Map();
  other.forEach((shift) => {
    const key = signature(shift);
    remaining.set(key, (remaining.get(key) || 0) + 1);
  });
  return schedule.filter((shift) => {
    const key = signature(shift);
    if (!remaining.get(key)) return true;
    remaining.set(key, remaining.get(key) - 1);
    return false;
  });
}


export function removedScheduleRows(schedule, other) {
  const currentChanges = changedScheduleRows(schedule, other);
  const remainingProposed = [...changedScheduleRows(other, schedule)];
  const identity = (shift) => shift.shift_key ?? shift.id;
  const unmatched = currentChanges.filter((shift) => {
    const key = identity(shift);
    const match = key == null ? -1 : remainingProposed.findIndex((candidate) => identity(candidate) === key);
    if (match < 0) return true;
    remainingProposed.splice(match, 1);
    return false;
  });
  // Legacy autoschedule snapshots have no stable shift identity. Pair their
  // remaining changes within each employee/day before treating extras as removals.
  return unmatched.filter((shift) => {
    const match = remainingProposed.findIndex((candidate) =>
      (identity(shift) == null || identity(candidate) == null) &&
      candidate.date === shift.date && memberId(candidate) === memberId(shift));
    if (match < 0) return true;
    remainingProposed.splice(match, 1);
    return false;
  });
}
